import { render, staticRenderFns } from "./SelectedUBAs.vue?vue&type=template&id=2d21545c&scoped=true&"
import script from "./SelectedUBAs.vue?vue&type=script&lang=js&"
export * from "./SelectedUBAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21545c",
  null
  
)

export default component.exports